// @ts-nocheck
/* eslint-disable */
import SceneControl from "./control";

export default class SceneControlEgg extends SceneControl {
	constructor(scene, itemId, options) {
		super(scene, itemId);
		this._options = options;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneControlEgg",
			type: "control"
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		let rd = super.getCreateData();
		rd.options = this._options;

		return rd;
	}

	/**
	 * Zavreni egg
	 */
	close() {
		this._onChange(this._scene.featureEvent("controlEggClose", true, true), arguments);
	}
}
